import { apiClient } from './client';

export type AdminRole = 'superadmin' | 'admin' | 'viewer';

export interface AdminProfile {
	id: string;
	email: string;
	displayName: string;
	role: AdminRole;
}

export const authApi = {
	async login(email: string, password: string): Promise<AdminProfile> {
		const { data } = await apiClient.post<{ admin: AdminProfile }>('/auth/login', { email, password });
		return data.admin;
	},

	async logout(): Promise<void> {
		await apiClient.post('/auth/logout');
	},

	async me(): Promise<AdminProfile | null> {
		try {
			const { data } = await apiClient.get<{ admin: AdminProfile }>('/auth/me');
			return data.admin;
		} catch {
			return null;
		}
	}
};
